import { z } from 'zod'

export const ADMINAGENTSPOSTCREATE_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsPostCreateResponseSchema = z.unknown()
export type AdminAgentsPostCreateResponse = z.infer<typeof adminAgentsPostCreateResponseSchema>
